import axios from 'axios';

const url = 'https://junkit.vonigo.com/api/v1/data/'

import store from '@/store';

export default class RegistrationService {

    public addClient(data: {}): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            axios
                .post(`${url}Clients/`, data, {
                    headers: {
                        "Content-Type": "application/json"
                    }
                })
                .then(res => {
                    resolve(res.data);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    public validateUserName(data: {}): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            axios
                .post(`${url}Contacts/`, data, {
                    headers: {
                        "Content-Type": "application/json"
                    }
                })
                .then(res => {
                    resolve(res.data);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    public addContact(data: {}): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            axios
                .post(`${url}Contacts/`, data, {
                    headers: {
                        "Content-Type": "application/json"
                    }
                })
                .then(res => {
                    resolve(res.data);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    public setContactsSignInCredentials(data: {}): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            axios
                .post(`${url}Contacts/`, data, {
                    headers: {
                        "Content-Type": "application/json"
                    }
                })
                .then(res => {
                    resolve(res.data);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    public authenticateContactForSelfSignIn(data: {}): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            axios
                .post(`${url}Contacts/`, data, {
                    headers: {
                        "Content-Type": "application/json"
                    }
                })
                .then(res => {
                    resolve(res.data);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    public getAContactsDetails(): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            axios
                .post(`${url}Contacts/`, {
                    securityToken: store.getters.token,
                    method: 1,
                    objectID: store.getters.contactId
                }, {
                    headers: {
                        "Content-Type": "application/json"
                    }
                })
                .then(res => {
                    resolve(res.data);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    public getAClientsDetails(): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            axios
                .post(`${url}Clients/`, {
                    "securityToken": store.getters.token,
                    "method": "1",
                    "objectID": store.getters.clientId
                }, {
                    headers: {
                        "Content-Type": "application/json"
                    }
                })
                .then(res => {
                    resolve(res.data);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    public updateAClient(data: object): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            axios
                .post(`${url}Clients/`, data, {
                    headers: {
                        "Content-Type": "application/json"
                    }
                })
                .then(res => {
                    resolve(res.data);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    public updateAContact(data: object): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            axios
                .post(`${url}Contacts/`, data, {
                    headers: {
                        "Content-Type": "application/json"
                    }
                })
                .then(res => {
                    resolve(res.data);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }
}
